import script from "./DebugInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DebugInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DebugInfo.vue?vue&type=style&index=0&id=7023ea4d&lang=scss"

const __exports__ = script;

export default __exports__